import { render, staticRenderFns } from "./PrivacyIndex.vue?vue&type=template&id=3777cb32&scoped=true"
import script from "./PrivacyIndex.vue?vue&type=script&lang=js"
export * from "./PrivacyIndex.vue?vue&type=script&lang=js"
import style0 from "./PrivacyIndex.vue?vue&type=style&index=0&id=3777cb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777cb32",
  null
  
)

export default component.exports